// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"766":"1dd588a2","814":"1df3f9e7"}[chunkId] + ".css";
};